module.exports = __webpack_public_path__ + "img/estimated-insurance-required-input1.19547032.svg";